<style scoped lang="scss">
@import "footer.scss";
</style>
<template>
  <div class="footer-wrap">
    <row class-name="footer-con">
      <i-col class-name="support-info" span="21">
        <div id="footer-td"></div>
      </i-col>
      <!--中英文切换-->
      <i-col span="3">
        <Dropdown placement="top" @on-click="changeLanguage">
          <a href="javascript:void(0)">
            {{curLanguage === 'zh-CN' ? '中文（简体）' : 'English'}}
            <Icon type="ios-arrow-down"></Icon>
          </a>
          <DropdownMenu slot="list">
            <DropdownItem :selected="selectedStatus" name="zh-CN">中文（简体）</DropdownItem>
            <DropdownItem :selected="!selectedStatus" name="en-US">English</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </i-col>
    </row>
  </div>
</template>
<script>
  import cookie from 'js-cookie';
  import bus from '../../libs/bus';
  import BaseLib from '../../base/BaseLib';

  export default {
    name: 'iFooter',
    props: ['footerType'],
    data() {
      return {
        curLanguage: bus.lang,
        selectedStatus: bus.lang === 'zh-CN',
        curYear: '',
        curLang: '',
        langType: {
          'zh-CN': 'zh_cn',
          'en-US': 'en_us',
        },
      };
    },
    methods: {
      changeLanguage(name) {
        this.curLanguage = name;
        this.selectedStatus = name === 'zh-CN';
        bus.$emit('on-change-lang', name);
        BaseLib.postMessage('msg-change-lang', name);
        cookie.set('i18next', name, { domain: '.talkingdata.com' });
      },
      pageFooterInit() {
        //eslint-disable-next-line
        const pageFooter = new TDUI.PageFooter({
          id: 'footer-td',
          language: 'zh',
          extendLinks: [{  //页头链接
            zh: '服务条款',
            en: 'The terms of service',
            link: 'http://www.talkingdata.com/terms.jsp?languagetype=zh_cn',
          },
          {
            zh: '隐私政策',
            en: 'Privacy Policy',
            link: 'https://www.talkingdata.com/privacy.jsp?languagetype=zh_cn',
          },
          {
            zh: '数据安全及个人信息保护承诺',
            en: 'Data Security', // 中英文
            link: 'https://www.talkingdata.com/security.jsp?languagetype=zh_cn',
          },
          {
            zh: '文档中心',
            en: 'Documents',
            link: 'http://doc.talkingdata.com/posts/21',
          },
          {
            zh: 'SDK下载',
            en: 'Download SDK',
            link: 'http://doc.talkingdata.com/posts/57',
          },
          ],
        });
        const pageFooterLanguage = bus.lang === 'zh-CN' ? 'zh' : 'en';
        pageFooter.setLanguage(pageFooterLanguage);
      },
    },
    mounted() {
      this.pageFooterInit();
      const self = this;
      bus.$on('on-change-lang', () => {
        self.pageFooterInit();
      });
      // this.curYear = new Date().getFullYear();
      // this.curLang = this.langType[bus.lang];
    },
  };
</script>
